/* unplugin-vue-components disabled */import { render } from "./treasureList.vue?vue&type=template&id=521bbf8c&scoped=true"
import script from "./treasureList.vue?vue&type=script&lang=js"
export * from "./treasureList.vue?vue&type=script&lang=js"

import "./treasureList.vue?vue&type=style&index=0&id=521bbf8c&scoped=true&lang=scss"
import "./treasureList.vue?vue&type=style&index=1&id=521bbf8c&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521bbf8c"]])

export default __exports__